import { Application } from '@hotwired/stimulus'

export const stimulus = Application.start()

// Configure Stimulus development experience
stimulus.debug = false
window.Stimulus = stimulus
